<template>
  <div>
    <el-row :gutter="5">
      <el-form ref="params" :model="params">
        <el-col :span="7" :xs="24">
          <!-- <el-date-picker
              v-model="time"
              :clearable="false"
              :picker-options="pickerOptions"
              end-placeholder="结束日期"
              range-separator="至"
              start-placeholder="开始日期"
              type="daterange"
              value-format="timestamp"/> -->
          <lp-date-picker
            ref="lpDatePicker"
            @finish="handleLpDatePickerChange"
          />
        </el-col>
        <el-col :span="2" :xs="12">
          <el-button type="primary" @click="search">搜索</el-button>
        </el-col>
        <el-col :span="2" :xs="12">
          <el-button plain type="success" @click="reset">重置</el-button>
        </el-col>
      </el-form>
    </el-row>
    <el-table :data="records" stripe>
      <el-table-column fixed label="充值编号" prop="thirdPartyOrderId" width="300"/>
      <el-table-column label="账户类型">
        <template #default="scope">
          <span v-if="scope.row.memberType == '1'"> 公众用户 </span>
          <span v-else-if="scope.row.memberType == '2'"> 小程序用户 </span>
          <span v-else-if="scope.row.memberType == '3'"> 电卡 </span>
        </template>
      </el-table-column>
      <el-table-column label="手机号" prop="phone" />
      <el-table-column label="订单金额" prop="payMoney" />
      <el-table-column label="支付方式">
        <template #default="scope">
          <span v-if="scope.row.typeOfPayment == '1'"> 微信支付 </span>
          <span v-else-if="scope.row.typeOfPayment == '2'"> 支付宝支付 </span>
          <span v-else-if="scope.row.typeOfPayment == '3'"> 代充 </span>
        </template>
      </el-table-column>
      <el-table-column label="订单时间">
        <template #default="scope">
          {{ timeFormat(scope.row.creatTime) }}
        </template>
      </el-table-column>
      <el-table-column label="状态">
        <template #default="scope">
          <span v-if="scope.row.state === '0'"> 未支付 </span>
          <span v-else-if="scope.row.state === '1'"> 已支付 </span>
          <span v-else-if="scope.row.state === '-1'"> 超时 </span>
        </template>
      </el-table-column>
    </el-table>
    <page :current="current" :size="size" :total="total" />
  </div>
</template>

<script>
import getPayLogByPage from "@/api/fund/pay-log-manage/getPayLogByPage";
import searchMixin from "@/mixin/searchMixin";
import createdMixin from "@/mixin/createMixin";
import pageMixin from "@/mixin/pageMixin";
import timeMixin from "@/mixin/timeMixin";
import Page from "@/components/Page";

export default {
  name: "UserManageDetailTwo",
  components: { Page },
  mixins: [createdMixin, pageMixin, searchMixin, timeMixin],
  data() {
    return {
      time: "",
      records: [],
      params: {
        memberType: 1,
        memberId: this.$route.params.id,
        startTime: undefined,
        endTime: undefined,
        sortName: "id",
        sortType: "DESC",
      },
    };
  },
  methods: {
    fetchData() {
      getPayLogByPage(this.params).then((res) => {
        this.total = res.data.total;
        this.records = res.data.records;
      });
    },
  },
};
</script>
